import { render, staticRenderFns } from "./FolderForm.vue?vue&type=template&id=c72286a4&scoped=true&lang=pug"
import script from "./FolderForm.vue?vue&type=script&lang=ts"
export * from "./FolderForm.vue?vue&type=script&lang=ts"
import style0 from "./FolderForm.vue?vue&type=style&index=0&id=c72286a4&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72286a4",
  null
  
)

export default component.exports